import { render, staticRenderFns } from "./Stockroom.vue?vue&type=template&id=c2e936aa&scoped=true"
import script from "./Stockroom.vue?vue&type=script&lang=js"
export * from "./Stockroom.vue?vue&type=script&lang=js"
import style0 from "./Stockroom.vue?vue&type=style&index=0&id=c2e936aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e936aa",
  null
  
)

export default component.exports